import { sound } from "@pixi/sound";
import { Point } from "pixi.js";
import { WinSeqComponent } from "../../components/winseq/WinSeqComponent";
import { betValueGlobal, isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { REEL_NUMBERS, SCATTER_ID, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { SoundConstants } from "../../gameClientEvents/soundConstants";
import { spinData } from "../../server/getServerResposesFun";
import { casinoEventEmitter } from "../CasinoChannelHandler";
import { DisplayComponent } from "../displays/DisplayComponent";
import { reelSpinEmitter } from "./ReelInit";
import { Reels } from "./Reels";

export class RoosterReels extends Reels {
    public symFinalPos: Point[][] = [];
    private symbolPosTaken: boolean = false;
    constructor() {
        super();
    }

    public override async startPlay(spinStype: string): Promise<[number, number, number?]> {

        // if (!spinData.dataFeatched) {
        //     await this.waitForData();
        // }

        // Cleanup any existing listeners for 'betDeclined' before adding a new one
        casinoEventEmitter.removeAllListeners('betDeclined');

        // Create a promise that resolves when 'betDeclined' is emitted
        const betDeclinedPromise = new Promise((resolve) => {
            // 'once' ensures automatic cleanup after the event is handled
            casinoEventEmitter.once('betDeclined', () => resolve('BetDeclined'));
        });

        console.log("startPlay for Freegame", this.running, spinStype, RespinIndex.value, spinData.respins.length);

        if (this.running) {
            return [0, 0];
        }


        // if (spinStype === "BASE") {
        //     this.fetchSpinResponse();  // note: no await here
        // }

        this.resetReelRunning(spinStype);
        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;

        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_enter") {
                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                console.log(`feature_enter triggered: ${freeGameTrigger}`);
                this.running = false;

                const accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                RespinIndex.increase();
                return [freeGameTrigger, accumulatedsWinAmount];
            }
            else if (respinType === "feature_exit" || respinType === "max_win_reached") {
                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                this.running = false;
                RespinIndex.increase();
                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];
            }
            else if (respinType === "reveal" || respinType === "collapse" || respinType === "fs_reveal" || respinType === "fs_collapse") {

                // await new Promise(resolve => setTimeout(resolve, 200));

                // if (respinType === "fs_reveal") {
                //     Manager.casinoChannelHandler.reportFeatureRoundStarted();
                //     const fsRevealPosition = fsRevealIndexes.length - fsRevealIndexes.indexOf(currentRespinIndex) - 1;
                //     Manager.casinoChannelHandler.reportUpdateFeatureCounter(fsRevealPosition);
                // }




                if (RespinIndex.value > 0) {
                    // await this.putsilverEggSpread(RespinIndex.value);
                    await this.cacadingReels(RespinIndex.value);
                    // await new Promise(resolve => setTimeout(resolve, 2000));
                }


                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal");


                if (!isNewSpin) {
                    // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value - 1].respinMultiplier);
                    // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value - 1].surgeMeter);
                }
                // if (respinType === "reveal") {
                //     reelSpinEmitter.emit('updateMultiplier', 0);
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }
                // else if (respinType === "fs_reveal") {
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }

                // Race between the reels and the 'betDeclined' event
                const betPromiseResult = await Promise.race([
                    this.startReels(RespinIndex.value, isNewSpin, spinStype), // Reel logic
                    betDeclinedPromise, // Event bet decline
                ]);

                if (betPromiseResult === 'BetDeclined') {
                    console.log('Bet was declined, breaking out of startPlay.');
                    this.resetReelRunning(spinStype);

                    this.reelMove1CompletePromise.then(() => {
                        this.resetSymbolPositions();
                    })

                    return [0, -1];
                }

                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;

                // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value].respinMultiplier);
                // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value].surgeMeter);

                // await this.addWildMultIntoMeter(RespinIndex.value);

                await this.animateWinningSymbols(RespinIndex.value); // this is just marking the winning symbol, not animating symbols here

                // update the global multiplier value & surge-meter



                // if (/*RespinIndex.value > 0 &&*/ spinData.respins[RespinIndex.value].multiplier > 1) {
                //     this.setMultValue(spinData.respins[RespinIndex.value].multiplier);
                // }

                // console.log("checking >10 win", spinData.respins[RespinIndex.value].winAmount, betValueGlobal)

                if (spinData.respins[RespinIndex.value].winAmount >= 10 * betValueGlobal) {
                    // console.log("inside >10 win", spinData.respins[RespinIndex.value].winAmount, betValueGlobal)

                   // reelSpinEmitter.emit('animateCharacter', 'win_2');
                }

                await this.lineToggle(RespinIndex.value); // this is actual function that animates symbols


                // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value].respinMultiplier);
                // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value].surgeMeter);

                // if (spinData.respins[RespinIndex.value].winAmount > 0) {
                //     this.resetNonwinSymbols();
                // }

                if (isNewSpin) {
                    respinWin = 0;
                    this.setAccWinValue(0);



                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;

                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                if (respinWin > 0) {
                    this.setAccWinValue(respinWin);
                }


                // Check for fs_collapse sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_collapse") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "fs_collapse") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {

                    this.running = false;
                    RespinIndex.increase();
                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }
                else {
                    if ((spinStype === "BASE" && (respinType === "reveal" || respinType === "collapse")) || respinType === "fs_reveal" || respinType === "fs_collapse") {

                    } else {
                        //await this.triggerOtherFeatures();
                        accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;
                    }

                }
            }
            //await this.callEndWinSeq(RespinIndex.value);
            if ((spinStype === "BASE" && (respinType === "reveal" || respinType === "collapse")) || respinType === "fs_reveal" || respinType === "fs_collapse") {
                //this.fetchFeatureInitMultipliers();
                RespinIndex.increase();
                console.log(`Respin is done for index ${RespinIndex.value}`);
            } else {
                //await this.triggerOtherFeatures();
                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;
                respinWin = spinData.respins[RespinIndex.value].winAmount;
                this.running = false;
                RespinIndex.increase();
                return [freeGameTrigger, respinWin, accumulatedsWinAmount];

            }

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }

    public override async startReels(currentRespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("inside startReels in class ReelSpin ")

        this.resetSymbolVisibility();
        this.quickStop = isQuickBtnOnGlobal;
        this.superQuickStop = isSuperQuickBtnOnGlobal;



        this.resetTweenGroup()


        let moveStep1CompleteResolve!: () => void;
        // Initialize moveStep1Complete as a new promise
        this.reelMove1CompletePromise = new Promise<void>((resolve) => {
            moveStep1CompleteResolve = resolve;
        });

        const promises: Promise<void>[] = [];

        this.allReelArray.forEach((reelObj, i) => {
            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.spinAReel(reelObj, isNewSpin).then(resolve);
                    clearTimeout(timeoutId);
                }, (isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : i * 100) : 0));
            });
            promises.push(promise);
        });

        await Promise.all(promises);

        // Resolve moveStep1Complete when this line is reached
        moveStep1CompleteResolve();

        await this.waitForData();
        reelSpinEmitter.emit(EventConstants.SPIN_STEP_DONE);

        if (spinData.respins[currentRespinIndex].type == "reveal" || spinData.respins[currentRespinIndex].type == "fs_reveal") {
            // this.updateGameMultiplier();
        }
        await this.callWinSeq(currentRespinIndex);


        //here is the scatter landing sound play logic
        this.setReelStopSounds(currentRespinIndex, isNewSpin);
        // console.log("scatterLand newScatters", this.newScatters);


        const promises2: Promise<void>[] = [];
        this.allReelArray.forEach((reelObj) => {

            const jurisdictionDelay = isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : (reelObj.reelIndex) * (100 + (spinStype === "BASE" ? this.spinTime : 0))) : 0;
            // (total_time - 1250)/5
            // for 5000ms value will be (5000-1250)/5 = 750 --- 350
            // for 3000ms value will be (3000-1250)/5 = 350 --- 150
            // for 2500ms value will be (2500-1250)/5 = 250 --- 
            // for 2000ms value will be (2000-1250)/5 = 150 
            // for 1000ms value will be (1000-1250)/5 = 0 --- 0 



            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.moveAReelStep2(reelObj, currentRespinIndex, isNewSpin).then(() => {
                        // console.log(`moveAReelStep2 completed for reelIndex: ${reelObj.reelIndex}`);
                        resolve();
                        reelObj.mask.alpha = 0;
                        reelObj.container.mask = null;
                    });
                    clearTimeout(timeoutId);
                }, jurisdictionDelay);
            });

            promises2.push(promise);
        });

        await Promise.all(promises2);

        //await this.jumpAnimGameMultiplier(isSuperQuickBtnOnGlobal);

        await this.allReelStop();
        this.updateSymbolPos();

        reelSpinEmitter.emit(EventConstants.REEL_SPIN_DONE);
        console.log("reel spin done");


    }

    protected updateSymbolPos(): void {
        if (!this.symbolPosTaken)
            this.symbolPosTaken = true;
        else
            return;
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.symFinalPos.push([]);
            for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                const point = this.allReelArray[i].symbols[j].symbol.getGlobalPosition();
                this.symFinalPos[i].push(point);
            }
        }
    }

    protected callWinSeq(currentRespinIndex: number): Promise<void> {
        return new Promise<void>(async (resolve) => {
            await DisplayComponent.get(WinSeqComponent).startWinSeqFeature(currentRespinIndex, resolve);
        });
    }

    protected callEndWinSeq(currentRespinIndex: number): Promise<void> {
        return new Promise<void>(async (resolve) => {
            await DisplayComponent.get(WinSeqComponent).endWinSeqFeature(currentRespinIndex, resolve);
        });
    }

    public override async lineToggle(currentRespinIndex: number) {

        // await this.makeNonwinSymbolDark();



        console.log("inside lineToggle");


        // if (this.running == false) { // toggel animation

        // this.resetWinContainer();// reset symbols before line toggle
        // this.lineWinText.text = "";

        // Call the function to process both win lines and win scatters repeatedly

        if (spinData.respins[currentRespinIndex].winAmount > 0) {
            // await new Promise(resolve => setTimeout(resolve, 100));
            this.makeNonwinSymbolDark();

            await this.processAllRepeatedly(currentRespinIndex);

            await this.blastAnimation(currentRespinIndex);
            //await this.callEndWinSeq(currentRespinIndex);

        }
        else {
            await new Promise(resolve => setTimeout(resolve, 100));
        }



        this.resetAllSymbols();

    }

    protected override async blastAnimation(currentRespinIndex: number): Promise<void> {


        const animationPromises: Promise<void>[] = [];
        const timescale = isSuperQuickBtnOnGlobal ? 2 : 1;

        spinData.respins[currentRespinIndex].cascadePositions?.forEach((position) => {
            // reels.forEach((symbol, posNum) => {

            const reelNum = position[0];
            const posNum = position[1];

            let spineSymbol = this.allReelArray[reelNum].symbols[posNum].symbol;
            let spineSymbolID = this.allReelArray[reelNum].symbols[posNum].id;

            const animationPromise = new Promise<void>((resolve) => {
                if(spineSymbolID == SCATTER_ID){
                    sound.play(SoundConstants.SCATTER_BLAST, { volume: 1 });
                }
                spineSymbol.state.setAnimation(0, "blast", false).listener = {
                    // spineSymbol.state.setAnimation(0, "land", false).listener = {
                    complete: () => {
                        spineSymbol.state.clearListeners();
                        resolve();
                    },
                };

                spineSymbol.state.timeScale = timescale;

            });
            DisplayComponent.get(WinSeqComponent).removeMultiHighlight(reelNum, posNum);
            animationPromises.push(animationPromise);

        });






        try {
            if (animationPromises.length > 0) {

                sound.play(SoundConstants.ROW_DROP, { volume: 0.3, speed: timescale });

                await Promise.all(animationPromises);
                // await new Promise(resolve => setTimeout(resolve, 100));

            }
        } catch (error) {
            console.error("Error during blastAnimation:", error);
            throw error;
        }
    }

}